
import bus from "@/bus";
import jwt_decode from "jwt-decode";
import moment from "moment";

const API_BASE = process.env.VUE_APP_API_BASE_PATH; //'http://dev-portal.whin.org/api';//'http://weather.whin.org/api/current-conditions';
const CURRENT_CONDITIONS_ENDPOINT = '/current-conditions';
const STATIONS_ENDPOINT = '/stations';
const LOGIN_ENDPOINT = '/login';


const api = {

  isLoggedIn() {
    const data = this.getDecodedSessionToken();

    if (data === null || data === undefined) {
      return false;
    }

    // Check token expired
    if (data.exp && data.exp < moment().unix()) {
      return false;
    }

    return true;
  },

  getLoggedInUserName() {
    const user = this.getLoggedInUser();
    return user.display_name || "an alliance member";
  },

  getLoggedInUser() {
    let data = this.getDecodedSessionToken();
    if (data === null) {
      data = {};
    }
    return data.user || {id: -1, display_name: "an alliance member"};
  },

  getDecodedSessionToken() {
    const token = this.getSessionToken();
    if (token === undefined || token === null) {
      return null;
    }
    try {
      return jwt_decode(token);
    } catch {
      return null;
    }
  },

  getSessionToken() {
    return window.localStorage.getItem("whin-session");
  },

  async logout() {
    window.localStorage.removeItem("whin-session");
    bus.$emit("session-logout");
  },

  async fetch_current_conditions() {
    // Check for local session token
    return this.makeGet(CURRENT_CONDITIONS_ENDPOINT);
  },
  async fetch_stations() {
    return this.makeGet(STATIONS_ENDPOINT);
  },

  async loginRequest(data) {
    let responsePromise = this.makeRequest(LOGIN_ENDPOINT, "POST", {
      'body': JSON.stringify(data)
    }, false);

    responsePromise.then((responseData) => {
      // Handle success case
      if (responseData.token !== undefined) {
        window.localStorage.setItem("whin-session", responseData.token);
        bus.$emit("session-login", {displayName: this.getLoggedInUserName()});
      }
    });
    return responsePromise;
  },

  makePost(endpoint, data) {
    return this.makeRequest(endpoint, "POST", {
      'body': JSON.stringify(data)
    }, true);
  },

  makeGet(endpoint) {
    return this.makeRequest(endpoint, "GET", {}, true);
  },


  async makeRequest(endpoint, method, options, shouldRetry) {

    let headers = {};
    if (this.isLoggedIn()) {
      let token = this.getSessionToken();
      headers['Authorization'] = `JWT ${token}`;
    }
    if (method === 'POST' || method === 'PUT') {
      headers['Content-Type'] = 'application/json';
    }

    let reqOptions = {
      headers: headers,
      method: method
    };
    if (options) {
      Object.assign(reqOptions, options);
    }
    let resp = await fetch(`${API_BASE}${endpoint}`, reqOptions);

    // Check for auth failure
    if (resp.status === 401) {
      // Clear local token
      this.logout();

      // Retry request without token
      if (shouldRetry) {
        resp = await fetch(`${API_BASE}${endpoint}`, reqOptions);
      } else {
        // auth failure data
        return resp.json();
      }
    }

    if (resp.ok) {
      return resp.json();
    } else {
      throw new Error("Error loading request");
    }
  }
};

export default api;